module.exports = __webpack_public_path__ + "static/assets/28a2a4b4f4ed9c82303efbc0945efa4a.gif";